import bg from "../../assets/BG.png"
import './ImageArea.css'
import { useSelector } from "react-redux"

const ImageArea = () => {

    const file = useSelector(state => state.file)
    const zoom = useSelector(state => state.image.zoom)
    const rotate = useSelector(state => state.image.rotate)
    const move = useSelector(state => state.move)
    const fileUrl =  URL.createObjectURL(file.currentFile ? file.currentFile : file.prevFile)
    const frameImg = useSelector(state => state.frame)
    const day = useSelector(state => state.day)
    const text = useSelector(state => state.text)

    const generateImg = () => {

        const imgStyle = {
            width:`100%`,
            height:`auto`,
            objectFit: `cover`,
            transform: `scale(${zoom}) rotate(${rotate}deg) translate(${move.vertical}px, ${move.horizontal}px)`,
        }

        return(
            <>
                <img src={fileUrl} alt="" style={imgStyle} />
            </>
        )
    }

    return(
        <div className="ImageArea">
            <div className="Image" id="outputImg">
                <img src={bg} alt="" id="bg" />
                <div className="mainPicContainer">
                {
                    generateImg()
                }
                </div>
                <img src={frameImg.pic} alt="" id="frame" />
                <h1 id="picText">{text}</h1>
                <img src={day} alt="" id="dayText"/>
            </div>
        </div>
    )
}

export default ImageArea